<div class="single-ticket-left-content__items" [ngClass]="{ 'full-width': isFullWidth }">
    <span class="title">{{ label }}</span>
    <span [ngClass]="{ 'description': !isSecondaryValue, 'secondary-description': isSecondaryValue }">
        <ng-content></ng-content>
    </span>
</div>
